import React from 'react';
import { Beer, Users, Award, Heart } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Beer,
      titleRo: 'Bere de Calitate',
      titleEn: 'Quality Beer',
      descRo: 'Selecție variată de bere proaspătă la draft',
      descEn: 'Varied selection of fresh draft beer'
    },
    {
      icon: Users,
      titleRo: 'Atmosferă Plăcută',
      titleEn: 'Pleasant Atmosphere',
      descRo: 'Spațiu confortabil pentru relaxare cu prietenii',
      descEn: 'Comfortable space to relax with friends'
    },
    {
      icon: Award,
      titleRo: 'Deservire Excelentă',
      titleEn: 'Excellent Service',
      descRo: 'Echipă prietenoasă și profesionistă',
      descEn: 'Friendly and professional team'
    },
    {
      icon: Heart,
      titleRo: 'Gustări Delicioase',
      titleEn: 'Delicious Snacks',
      descRo: 'Meniu variat de fructe de mare și gustări',
      descEn: 'Varied menu of seafood and snacks'
    }
  ];

  return (
    <section id="about" className="py-20" style={{ backgroundColor: 'var(--beige-warm)' }}>
      <div className="container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="mb-6">{t.about.title}</h2>
          <p className="text-lg leading-relaxed" style={{ color: 'var(--brown-medium)' }}>
            {t.about.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-white hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div
                  className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4"
                  style={{ backgroundColor: 'var(--amber-light)' }}
                >
                  <Icon size={32} style={{ color: 'var(--brown-dark)' }} />
                </div>
                <h3 className="text-xl font-semibold mb-2" style={{ color: 'var(--brown-dark)' }}>
                  {feature[`title${t.about.title === 'Despre noi' ? 'Ro' : 'En'}`]}
                </h3>
                <p style={{ color: 'var(--brown-medium)' }}>
                  {feature[`desc${t.about.title === 'Despre noi' ? 'Ro' : 'En'}`]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;